import { render, staticRenderFns } from "./CountBox.vue?vue&type=template&id=58b81ad0&scoped=true&"
import script from "./CountBox.vue?vue&type=script&lang=js&"
export * from "./CountBox.vue?vue&type=script&lang=js&"
import style0 from "./CountBox.vue?vue&type=style&index=0&id=58b81ad0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b81ad0",
  null
  
)

export default component.exports